import React from "react";

export default function HeadquartersCard({
  title,
  subtitle,
  children,
  style = {},
}) {
  return (
    <section
      style={{
        background: "#13293d",
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: 12,
        padding: 20,
        boxShadow: "0 10px 30px rgba(0,0,0,0.14)",
        marginBottom: 20,
        ...style,
      }}
    >
      {title && (
        <h2
          style={{
            marginTop: 0,
            marginBottom: subtitle ? 8 : 16,
            color: "#ffffff",
          }}
        >
          {title}
        </h2>
      )}

      {subtitle && (
        <div
          style={{
            color: "#9fb0c3",
            marginBottom: 18,
          }}
        >
          {subtitle}
        </div>
      )}

      {children}
    </section>
  );
}
